<template>
  <main class="tag" v-if="payload">
    <h1 class="title ff-sans fs-xl" v-html="`#${$route.params.tag}`"></h1>
    <div class="tag-work">
      <div class="tag-work__item" v-for="(work, key) in payload.works" :key="`tag-work${key}`">
        <router-link :to="getLink(work.type, work.slug)">
          <img :src="work.slideshow[0].image.url" v-if="work.slideshow && work.slideshow[0].type === 'image'"/>
          <div class="no-image" v-else></div>
        </router-link>
        <div class="tag-work__item-details">
          <p v-html="work.title"></p>
          <p v-html="getDesigners(work.designers)"></p>
          <p v-html="work.year"></p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import DataService from '@/services/data-service'
import MetaService from '@/services/meta-service'

export default {
  name: 'Tag',
  data() {
    return {
      payload: null,
      designers: null
    }
  },
  methods: {
    getLink(type, item) {
      return `/${type}/${item}`
    },
    getDesigners(designers) {
      if (designers) {
        let designersStr = ''
        designers.forEach((designer, index) => {
          designersStr += `${designer.first_name} ${designer.last_name}`
          if (designers.length > 1 && index < designers.length - 1) {
            designersStr += ', '
          }
        })
        return designersStr
      }
    },
    setData(payload) {
      this.payload = payload
      MetaService.updateMeta(payload)
    }
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.postData.tag = to.params.tag

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        this.setData(payload)
        next()
      })
  },
  beforeRouteEnter(to, from, next) {
    to.meta.postData.tag = to.params.tag

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        next(vm => {
          vm.setData(payload)
        })
      })
  }
}
</script>

<style lang="scss" scoped>
.tag {
  @include page;

  &__title {
    font-size:$heading;
    padding:0 0 10px 0;
  }

  &-work {
    display:flex;
    flex-wrap: wrap;
    align-items: flex-start;
    &__item {
      width: calc(25% - 7.5px);
      margin:0 10px 20px 0;
      display:flex;
      flex-direction: column;
      justify-content: flex-end;
      &-details {
        margin:10px 0 0 0;
        p {
          line-height: $content-line-height;
        }
      }

      &:nth-child(4n + 4) {
        margin-right:0;
      }

      img, .no-image {
        width:100%;
        height:calc((25vw - 2rem - (30px / 4)) * 0.75);
        object-fit:cover;
        object-position: 50% 50%;
        float:left;
        filter: grayscale(100) contrast(1.15);
        transition:filter 180ms ease-in-out;
      }
      .no-image {
        background-color:#cecece;
      }

      &:hover {
        img {
          filter: grayscale(0);
        }

        .tag-work__item-details {
          p {
            &:first-child {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: $mobile) {
    &__title {
      font-size:$heading--m;
      margin:0 0 1rem 0;
    }
    &-work {
      &__item {
        width:100%;
        margin:0 0 10px 0;
        img, .no-image {
          // height:calc((100vw - 1.5rem) * 1);
          min-height:calc((100vw - 1.5rem) * 0.75);
          max-height:calc((100vw - 1.5rem) * 1);
          object-position: 0% 100%;
        }
        &__details {
          margin:0.75rem 0 0 0;
          height:unset;
          p {
            font-size:$body--m;
          }
        }
      }
    }
  }
}
</style>
